import { round2, vals } from "@/lib/format";

export const currentShift = (view) => vals(view.shifts).filter((s) => s.status === "open").sort((a, b) => b.opened_at.localeCompare(a.opened_at))[0] || null;

const inRange = (iso, from, to) => iso && iso >= from && iso <= to;
const sum = (arr, f) => round2(arr.reduce((s, x) => s + (Number(f(x)) || 0), 0));

export function shiftReport(view, shift) {
  const from = shift.opened_at;
  const to = shift.closed_at || new Date().toISOString();
  const sales = vals(view.sales).filter((s) => inRange(s.created_at, from, to));
  const cashSales = sales.filter((s) => !["credit", "card", "split", "house", "advance", "transfer"].includes(s.payment));
  const houseSales = sales.filter((s) => s.payment === "house");
  const splitSales = sales.filter((s) => s.payment === "split");
  const cardSales = sales.filter((s) => s.payment === "card");
  const creditSales = sales.filter((s) => s.payment === "credit");
  const payments = vals(view.payments).filter((p) => inRange(p.created_at, from, to));
  const returns = vals(view.returns).filter((r) => inRange(r.created_at, from, to));
  const expenses = vals(view.expenses).filter((e) => inRange(e.created_at, from, to));
  const moves = shift.moves || [];
  const r = {
    from, to, count: sales.length,
    gross: sum(sales, (s) => s.subtotal ?? s.total), discounts: sum(sales, (s) => s.discount), net: sum(sales, (s) => s.total),
    cash_sales: round2(sum(cashSales, (s) => s.total) + sum(splitSales, (s) => s.split?.cash)), credit_sales: sum(creditSales, (s) => s.total),
    card_sales: round2(sum(cardSales, (s) => s.total) + sum(splitSales, (s) => s.split?.card)), split_sales: sum(splitSales, (s) => s.total), house_sales: sum(houseSales, (s) => s.total),
    credit_paid_now: sum(creditSales, (s) => s.paid), credit_given: round2(sum(creditSales, (s) => s.total - (s.paid || 0)) + sum(splitSales, (s) => s.split?.credit)),
    debt_payments: sum(payments, (p) => (p.kind === "refund" ? -p.amount : p.amount)),
    cash_refunds: sum(returns.filter((x) => x.refund !== "credit"), (x) => x.amount), returns_total: sum(returns, (x) => x.amount),
    expenses: sum(expenses, (e) => e.amount),
    cash_in: sum(moves.filter((m) => m.kind === "in"), (m) => m.amount), cash_out: sum(moves.filter((m) => m.kind === "out"), (m) => m.amount),
    drawer_opens: moves.filter((m) => m.kind === "open").length,
    charity_cash: round2(sum(cashSales, (s) => s.charity || 0)), charity_total: round2(sum(sales, (s) => s.charity || 0)),
    opening_float: Number(shift.opening_float) || 0,
  };
  r.expected = round2(r.opening_float + r.cash_sales + r.credit_paid_now + r.debt_payments + r.cash_in - r.cash_out - r.cash_refunds - r.expenses + r.charity_cash);
  return r;
}
